import AContainer from "./ExtendedObjects/AContainer.js";
import TouchableImage from "./TouchableImage.js";

export default class InteractableObject extends AContainer
{
    constructor(scene, x, y, texture, frame, origin, interactiveCoords)
    {
        super(scene, x, y, texture, frame, origin);

        this.image = new TouchableImage(scene, 0, 0, texture, frame, origin = .5, interactiveCoords);
        this.add(this.image);

        this.image.onRotate = (rotation)=>{
            this.rotation += rotation;
        };

        this.image.onScale = (scale)=>{
            this.image.setScale(this.image.scaleX + scale * .015);
        };

        this.isManipulating = false;
        this.prevTheta = 0;
        this.prevDistance = 0;

        this.maxDimension = 2200;
        this.minDimension = 0;
        this.activePointer = null;
 
        this.onChange = null;
        this.isActive = true;

        this.image.on("pointerdown", ()=>{
            if(this.isManipulating) return;
            this.activePointer = this.scene.input.activePointer;
        });

        this.createUI();
    }

    toggleUI(toggle)
    {
        this.isActive = toggle;
        if(this.manipulationIcon != null) this.manipulationIcon.visible = toggle;
        if(this.outlineImage != null) this.outlineImage.visible = toggle;
    }
    
    createUI()
    {
        this.buttonPadding = 0;

        this.outlineImage = this.scene.addNineSlice(0, 0, "Outline.png", 3, 3, 3, 3, 500, 500, this);
        this.manipulationIcon = this.scene.addImage((this.image.displayWidth) * .5 + this.buttonPadding, (this.image.displayHeight) * -.5 - this.buttonPadding, "ResizeIcon.png", .5, this);
        this.updateSize();
        this.manipulationIcon.setInteractive();
        this.manipulationIcon.on('pointerdown', (pointer)=>{
            this.image.updateTransform = false;
            this.isManipulating = true;
            this.activePointer = pointer;

            this.prevDistance = this.distance;
            this.prevTheta = this.theta;
        });
        if(this.scene.game.isMobile)
        {
            this.manipulationIcon.setScale(3);
        }
        else
        {
            this.manipulationIcon.setScale(1.5);
        }
        
    }

    preUpdate()
    {
        if(!this.isActive) return; 

        if(this.isManipulating && !this.activePointer.isDown)
        {
            this.isManipulating = false;
            this.image.updateTransform = true;

            this.scene.killTween(this.image);

            this.updateSize();
            // if(this.onChange != null) this.onChange();
        }
        if(this.activePointer != null)
        {
            if(!this.activePointer.active || !this.activePointer.isDown)
            {
                this.onChange();
                this.activePointer = null;
            }
        }

        this.image.preUpdate();

       
        if(this.isManipulating)
        {
            this.rotation += this.theta - this.prevTheta;
            this.prevTheta = this.theta;

            let ratio = 1;
            let destSize = {width: 100, height: 100};

            if(this.image.width > this.image.height)
            {
                let modifier = 24;
                ratio = this.image.width / this.image.height;
                destSize.width = this.image.displayWidth + ((this.distance - this.prevDistance) * modifier) * ratio;
                destSize.height = this.image.displayHeight + ((this.distance - this.prevDistance) * modifier);

                if(destSize.width > this.maxDimension * ratio) 
                {
                    destSize.width = this.maxDimension * ratio;
                    destSize.height = this.maxDimension;
                }
                if(destSize.width < this.minDimension * ratio) 
                {
                    destSize.width = this.minDimension * ratio;
                    destSize.height = this.minDimension;
                }
                this.scene.addTween(this.image, 100, {displayWidth: destSize.width, displayHeight: destSize.height});
            }
            else
            {
                let modifier = 24;
                ratio = this.image.height / this.image.width;
                destSize.width = this.image.displayWidth + ((this.distance - this.prevDistance) * modifier);
                destSize.height = this.image.displayHeight + ((this.distance - this.prevDistance) * modifier) * ratio;

                if(destSize.height > this.maxDimension * ratio) 
                {
                    destSize.width = this.maxDimension;
                    destSize.height = this.maxDimension * ratio;
                }
                if(destSize.height < this.minDimension * ratio) 
                {
                    destSize.width = this.minDimension;
                    destSize.height = this.minDimension * ratio;
                }
                this.scene.addTween(this.image, 100, {displayWidth: destSize.width, displayHeight: destSize.height});
            }

            
            this.prevDistance = this.distance;
        }

        this.updateSize();
    }

    updateSize()
    {
        if(this.outlineImage != null) this.outlineImage.setSize(this.image.displayWidth, this.image.displayHeight);
        if(this.manipulationIcon != null) this.manipulationIcon.setPosition((this.image.displayWidth) * .5 + this.buttonPadding, (this.image.displayHeight) * -.5 - this.buttonPadding);
    }

    get theta()
    {
        let pntr = this.activePointer;
        return Math.atan2(this.globalY - pntr.y, this.globalX - pntr.x);
    }

    get distance()
    {
        return this.hypot(this.activePointer.x - this.globalX, this.activePointer.y - this.globalY);
    }

    get globalY()
    {
        let yTotal = this.y;
        let parent = this.parentContainer;

        while(parent != null)
        {
            yTotal += parent.y;
            parent = parent.parentContainer;
        }
        return yTotal;
    }

    get globalX()
    {
        let xTotal = this.x;
        let parent = this.parentContainer;
        while(parent != null)
        {
            xTotal += parent.x;
            parent = parent.parentContainer;
        }
        return xTotal;
    }

    hypot() 
    {
        let y = 0;
        let i = arguments.length;
        while (i--) y += arguments[i] * arguments[i];
        return Math.sqrt(y);
    }
}